import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, PlatormFrontendModel, SesService} from '@spa/api';
import {RemovePlatformFrontendForm} from 'appEntries/panel/forms';
import {PlatformFrontendAddMessages} from 'appAssets/messages';
import {AlertsService} from 'appShared/services';
import {PlatformFrontendFormErrorStatesEnum} from 'appEntries/panel/enums';
import {PermissionRulesTrait} from 'appEntries/panel/traits';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-platform-frontend-remove',
    templateUrl: './platform-frontend-remove.component.html',
    styleUrls: ['./platform-frontend-remove.component.scss']
})
export class PlatformFrontendRemoveComponent extends PanelBaseMarketDataFormDialogComponent<PlatformFrontendRemoveComponent> {
    @Input() public platforms: PlatormFrontendModel[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            platforms: PlatormFrontendModel[]
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<PlatformFrontendRemoveComponent>,
    ) {
        super(dialogRef, alertsService);
        this.permissionRule = PermissionRulesTrait.getPlatformFrontendManagementPermissionRule();
        this.config = data.config;
        this.platforms = data.platforms;
    }

    getSuccessFormMessage(): string {
        return PlatformFrontendAddMessages.PlatformFrontendDeletionSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError) {
        if (error.status === PlatformFrontendFormErrorStatesEnum.DeletePlatformFrontendFailed) {
            return PlatformFrontendAddMessages.PlatformFrontendDeletionFailed.message;
        }

        return PlatformFrontendAddMessages.UnknownError.message;
    }

    initForm(): void {
        this.form = new RemovePlatformFrontendForm(this.sesService, this.platforms);
        this.form.initForm();

        const formChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const selectedBundleFirstIndex = Object.keys(data).findIndex((key: string) => data[key] > 0);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundleFirstIndex < 0;
        });

        this.subscriptions.push(formChangeSubscription);
    }
}
